import { sortableEntitySchema } from './sortable-entity.js';
import { requiredNamedObjectSchema } from './named-object.js';
import { epochDurationSchema } from './epoch-duration.js';
import { IllegalArgumentError } from 'faro-common-model';
import { z } from 'zod';
import { StudyEntityType } from './study-entity-type.js';
import { uuidish } from '../utils/uuidish.js';
import { nullishToUndefined } from '../utils/nullishToUndefined.js';
/**
 * These are EpochType#id values that have business meaning and rules
 * associated with them.
 * NOTE: These values must match the database ID values.
 * See epoch_type values within faro-db
 */
export var KnownEpochTypeId;
(function (KnownEpochTypeId) {
    KnownEpochTypeId["Screening"] = "screening";
    KnownEpochTypeId["Treatment"] = "treatment";
    KnownEpochTypeId["FollowUp"] = "follow-up";
    KnownEpochTypeId["LongTermFollowUp"] = "long-term-follow-up";
})(KnownEpochTypeId || (KnownEpochTypeId = {}));
export const epochTitleMaxLength = 120;
export const epochDescriptionMaxLength = 250;
export const epochSchema = z.object({
    ...sortableEntitySchema.shape,
    entityType: z.literal(StudyEntityType.Epoch).default(StudyEntityType.Epoch),
    epochType: requiredNamedObjectSchema,
    epochConfigurationId: uuidish,
    title: z.string().max(epochTitleMaxLength).nullish().transform(nullishToUndefined).optional(),
    description: z.string().max(epochDescriptionMaxLength).nullish().transform(nullishToUndefined).optional(),
    duration: epochDurationSchema,
});
export function toEpoch(epoch) {
    const result = epochSchema.safeParse(epoch);
    if (!result.success) {
        throw new IllegalArgumentError(`Invalid Epoch object. ${result.error.message}`);
    }
    return result.data;
}
//# sourceMappingURL=epoch.js.map